import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/modules/article/components/article-list-paginated/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/vercel/path0/modules/contact-form/components/form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompaniesListAll"] */ "/vercel/path0/modules/finkn/companies/content-blocks/components/companies-list-all/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompaniesListLinksContainer"] */ "/vercel/path0/modules/finkn/companies/content-blocks/sanity/companies-list-links/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/modules/finkn/components/table-of-contents/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleContent"] */ "/vercel/path0/modules/finkn/content-blocks/components/collapsible-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieList"] */ "/vercel/path0/modules/finkn/content-blocks/components/cookie-list/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqListAll"] */ "/vercel/path0/modules/finkn/faq/content-blocks/components/faq-list-all/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqListAreaContainer"] */ "/vercel/path0/modules/finkn/faq/content-blocks/sanity/faq-list-area/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/modules/finkn/field-of-area/content-blocks/components/field-of-area-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/finkn/nemnd/sanity/frontpage/PageDraft.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/accordion/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/modules/foundation/components/image/ImageBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
